import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { environment } from '../../../../environments/environment'
import * as firebase from 'firebase';
import { MatChipInputEvent, ErrorStateMatcher, MatDialog } from '@angular/material';
import { Subscription } from '../../../../../node_modules/rxjs/Subscription';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { Http, Headers } from '@angular/http';
import { ApiService } from '../../../core/services/api.service';
import { tokenCreator } from '../../../core/services/token.service';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { supportsWebAnimations } from '@angular/animations/browser/src/render/web_animations/web_animations_driver';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';

@Component({
    selector: 'app-addtosubkeyword',
    templateUrl: './addtosubkeyword.component.html',
    styleUrls: ['./addtosubkeyword.component.scss'],
})
export class AddtosubkeywordComponent implements OnInit, OnDestroy {
    @ViewChild('input') input: ElementRef;
    @ViewChild('f') myForm;
    myControl: FormControl = new FormControl();
    name: FormControl = new FormControl();
    rakip: FormControl = new FormControl();
    myModel = true;
    // checked = false;
    // checked1 = false;
    // checked2 = false;
    indeterminate = false;
    labelPosition = 'after';
    checkVal: any;
    disabled = false;
    roleName: any;
    form: FormGroup;
    formErrors: any;
    company: any;
    showForm = true;
    roles: string;
    list = [];
    categories = environment.categoriesModel;
    sub: Subscription;
    text: any;
    brandList = [];
    filteredOptions: Observable<string[]>;
    filteredOptions2: Observable<string[]>;
    brands = [];
    item = [];
    itemSub = [];
    itemIndex: any = null;

    waiter = false;
    constructor(
        private formBuilder: FormBuilder,
        private http: Http,
        private afs: AngularFirestore,
        private httpclient: HttpClient,
        private dialog: MatDialog,
        private api: ApiService
    ) {
        // const firestore = firebase.firestore();
        // const settings = { timestampsInSnapshots: true };
        // firestore.settings(settings);


        this.formErrors = {
            category: {},
            mail: {},
            firstname: {},
            lastname: {},
            role: {},
            name: {},
            // uniqueName: {},
            password: {}
        };
    }
    onRole(event) {
        this.checkVal = [];
        this.checkVal = event.value;
    }


    ngOnInit() {
        this.roles = localStorage.getItem('currentUserRole');

        this.filteredOptions = this.name.valueChanges
            .pipe(
                startWith(''),
                map(val => this.filter(val))
            );
        this.filteredOptions2 = this.rakip.valueChanges
            .pipe(
                startWith(''),
                map(val => this.filter(val))
            );

        this.form = this.formBuilder.group({
            category: ['', Validators.required],
            name: [''],
            criter: [''],
            mainkeyword: ['']

            // uniqueName: ['', Validators.required]
        });
        this.form.valueChanges.subscribe((a) => {

            this.roleName = a.role;

            this.onFormValuesChanged();
        });
        this.form.get('category').valueChanges.subscribe((a) => {
            this.waiter = true;
            this.getBrand(a);
        })
    }

    filter(val: string): string[] {
        return this.brandList.filter(option =>
            option.toLowerCase().indexOf(val.toLowerCase()) === 0);
    }
    nested(data) {
        data.forEach(element => {
            return element.name
        })
    }
    getBrand(category) {
        console.log(category);

        // if (this.sub) {
        //   this.sub.unsubscribe();
        // }
        this.brandList = [];

        this.sub = this.afs.collection('brands', ref => ref.where('category', '==', category)).valueChanges().subscribe(data => {
            data.forEach(a => {
                this.brandList.push(a['name']);
            });
            this.waiter = false;



        });


    }


    onFormValuesChanged() {
        for (const field in this.formErrors) {
            if (!this.formErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.formErrors[field] = {};

            // Get the control
            const control = this.form.get(field);

            if (control && control.dirty && !control.valid) {
                this.formErrors[field] = control.errors;
            }
        }
    }
    edit(item, index) {
        this.text = item.name;
        this.itemIndex = index;

        // this.api.sqlPost('corporate/editKeyword', { keyword: item.name, category: category }).map(res => res.json()).toPromise().then(() => {
        //     this.selectKeyword(category);
        // })

    }

    changeText(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '')
            .replace(/\-/g, '')
            .replace(/\'/g, '')
            .replace(/\s/g, '')
            .toLowerCase();
    }


    send() {
        let criter = this.form.get('criter').value;
        let category = this.form.get('category').value;
        let name = this.name.value;
        let mainkeyword = this.form.get('mainkeyword').value;

        if (this.name.value) {
            console.log(mainkeyword);
            let uniqueName = this.changeText(this.name.value);
            this.itemSub.forEach(items => {
                console.log(items)
                this.api.sqlPost('corporate/subKeywordBrand', {
                    subkeyword: items.name,
                    category: category,
                    uniqueName: uniqueName,
                    keyword: mainkeyword

                }).map(res => res.json()).subscribe(d => {
                    console.log(d);
                });
            });

        }
        else {
            console.log(mainkeyword);


            this.itemSub.forEach(items => {
                console.log(items)
                this.api.sqlPost('corporate/subKeywordCategory', {
                    subkeyword: items.name,
                    keyword: mainkeyword,
                    category: category

                }).map(res => res.json()).subscribe(d => {
                    console.log(d);
                });
            });
        }
        this.itemSub = [];
        this.form.reset();






        // let createAuth = firebase.auth().createUserWithEmailAndPassword(mail, password);
        // let createUser = createAuth.then(data => {

        //     this.api.sqlPost('corporate/insertCorporateMember', {
        //         uniqueName: uniqueName,
        //         membershipDate: this.dateFormat(date)
        //     }).map(res => res.json()).subscribe(d => {
        //         console.log(d);
        //         console.log(uniqueName);
        //     })
        //     return data.uid;
        // }).then((uid) => {
        //     this.SendVerificationMail({ email: mail, nameto: `${firstname} ${lastname}`, uid: uid, password: password });

        //     this.showForm = false;
        //     setTimeout(() => {
        //         // this.form.reset()
        //         this.showForm = true;
        //         // this.name.reset();
        //         // this.brands = [];
        //         this.waiter = false;
        //     });

        // });
    }

    SendVerificationMail(userinfo: Object) {
        const token = tokenCreator();
        const option = {
            data: {
                customToken: token,
                email: userinfo['email'],
                nameTo: userinfo['nameto'],
                nameFrom: 'bigadvice-Analytics'
            }
        }
        console.log(userinfo);
        console.log(token, 'token');
        this.request(option);

    }
    request(option) {

        const sub = this.httpclient.post('https://api.bigadvice.com/email/sendEmailVerificationCorporate', option.data)
            .subscribe((res) => {
                if (res === "OK") {
                    sub.unsubscribe();
                }
            });
    }
    addCriteria(criter, category, keyword) {


        console.log(criter, 'criter');


        if (this.itemIndex !== null && !this.name.value) {

            this.api.sqlPost('corporate/editKeyword',
                { subKeyword: this.itemSub[this.itemIndex].name, category: category, editKeyword: criter, keyword: keyword }).map(res => res.json()).toPromise().then(() => {
                    // this.selectKeyword(category);
                })
            this.itemSub[this.itemIndex].name = criter;
        }
        else if (this.itemIndex !== null && this.name.value) {
            console.log("girdi");

            this.api.sqlPost('corporate/editKeyword',
                {
                    subKeyword: this.itemSub[this.itemIndex].name, category: category,
                    keyword: keyword,
                    editKeyword: criter, uniqueName: this.changeText(this.name.value)
                }).map(res => res.json()).toPromise().then(() => {
                    // this.selectKeyword(category);
                })
            this.itemSub[this.itemIndex].name = criter;
        }
        else {
            this.itemSub.push({ name: criter });
        }
        this.itemIndex = null;
        this.text = "";


        // console.log(criter, 'criter');



    }
    selectKeyword(category) {
        console.log(category);
        this.api.sqlPost('corporate/getKeywordCategory', { category: category }).map(res => res.json()).toPromise().then(data => {
            this.item = [];
            data.forEach(key => {
                this.item.push({ name: key.keyword });
            });
        })

    }
    selectSubKeyword(keyword, category) {
        console.log(keyword);
        console.log(this.name.value);

        if (this.name.value) {

            this.api.sqlPost('corporate/getSubKeywordBrand', {
                category: category, keyword: keyword,
                uniqueName: this.changeText(this.name.value)
            }).map(res => res.json()).toPromise().then(data => {
                this.itemSub = [];
                data.forEach(key => {
                    console.log(key.subKeyword);
                    this.itemSub.push({ name: key.subKeyword });
                });
            });
        }
        else {
            this.api.sqlPost('corporate/getSubKeyword', { category: category, keyword: keyword }).map(res => res.json()).toPromise().then(data => {
                this.itemSub = [];
                data.forEach(key => {
                    console.log(key.subKeyword);
                    this.itemSub.push({ name: key.subKeyword });
                });
            });
        }

    }
    selectKeywordBrand(uniqueName, category) {
        if (uniqueName) {
            let brandName = this.changeText(uniqueName);
            console.log(brandName);
            this.api.sqlPost('corporate/getKeywordBrand', { category: category, uniqueName: brandName }).map(res => res.json()).toPromise().then(data => {
                this.item = [];
                data.forEach(key => {
                    console.log(key);
                    this.item.push({ name: key.keyword });
                });
            });
        }

    }
    addCriteria2(criter2) {
        console.log(criter2, 'criter2');

    }
    delete(item, category, keyword) {
        console.log(item);
        console.log(category);
        console.log(keyword);
        if (this.name.value) {
            this.api.sqlPost('corporate/deleteKeyword', {
                subKeyword: item.name,
                keyword: keyword,
                category: category, uniqueName: this.changeText(this.name.value)
            }).map(res => res.json()).toPromise().then((data) => {
                this.itemSub = [];
                data.forEach(key => {
                    this.itemSub.push({ name: key.subKeyword });
                });

                // this.selectKeywordBrand(this.changeText(this.name.value), category);
            });
        }
        else {
            this.api.sqlPost('corporate/deleteKeyword', { subkeyword: item.name, keyword: keyword, category: category }).map(res => res.json()).toPromise().then((data) => {
                this.itemSub = [];
                data.forEach(subkeywords => {
                    this.itemSub.push({ name: subkeywords.subKeyword });

                });
            });
        }


    }

    dateFormat(data) {
        if (data.length == 10) {
            return data;
        }
        var dd = data.getDate();
        var mm = data.getMonth() + 1; //January is 0!
        var yyyy = data.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }

        data = yyyy + '-' + mm + '-' + dd;
        return data;
    }
    addSelect(event) {
        let value = event.option.value;
        if (value) {
            console.log(value);

            this.brands.push({ name: value, uniqueName: this.changeText(value) });
            console.log("brands");
            console.log(this.brands);


        }
        this.input.nativeElement.value = null;
    }
    addCategory(event: MatChipInputEvent): void {
        this.brands = [];
        const input = event.input;
        const value = event.value;

        // Add category
        if (value) {
            console.log("value");
            console.log(value);

            this.brands.push({ name: value, uniqueName: this.changeText(value) });
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    removeCategory(category) {
        const index = this.brands.indexOf(category);

        if (index >= 0) {
            this.brands.splice(index, 1);
        }
    }
    ngOnDestroy() {
        if (this.sub)
            this.sub.unsubscribe();
    }

    includeString(role, value) {
        if (role.includes(value)) {
            return role;

        }

    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/addtosubkeyword/addtosubkeyword.component.ts